function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs30"
});

var _ref3 = /*#__PURE__*/React.createElement("style", {
  id: "style2",
  type: "text/css"
}, "\n\t.st0welcome{fill-rule:evenodd;clip-rule:evenodd;fill:#F7DB3A;}\n\t.st1welcome{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2welcome{filter:url(#Adobe_OpacityMaskFilterwelcome);}\n\t.st3welcome{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4welcome{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;}\n\t");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-148.000000, -255.000000)",
  id: "Desk_connection-Copy"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(117.000000, 246.000000)",
  id: "illus_welcome"
}, /*#__PURE__*/React.createElement("path", {
  d: "M113.6,342.9c-100.7,27.6-125.1,141.4,16.6,151c141.7,9.6,263.6-41.6,306.6-145.5     c43-103.9-11.5-206.2-87.1-166.8C254.7,231.1,224.3,312.6,113.6,342.9z",
  className: "st0welcome",
  id: "Fill-1"
}))));

var SvgIllusWelcome = function SvgIllusWelcome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "486px",
    width: "421px",
    style: {
      enableBackground: "new 0 0 421 486"
    },
    viewBox: "0 0 421 486",
    y: "0px",
    x: "0px",
    id: "Calque_1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllusWelcome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illus_welcome.417cbc40.svg";
export { ForwardRef as ReactComponent };